import { useParams } from "react-router-dom";

const useOrganization = (): string => {
  const { organizationId } = useParams();
  if (!organizationId) {
    throw new Error('useOrganization must be used within an organization route');
  }
  return organizationId;
};

export default useOrganization;
